<template>
  <div
    class="shrink-0 w-[--pergunta-width]"
    :class="{
      isCheckbox: tipoOpcao?.checkbox,
    }"
  >
    <template
      v-for="alternativa in alternativas"
      :key="alternativa.id"
    >
      <ItemAlternativa
        :tipo-opcao
        :assessment
        :alternativa
        :title="alternativa.titulo"
        :description="alternativa.descricao"
        :color="respostas?.[alternativa.id]?.respostas?.at(-1)?.cor"
        @click:evidencia="$emit('click:evidencia', $event)"
      />
    </template>
  </div>
</template>

<script setup>
import ItemAlternativa from 'components/PagePergunta/ItemAlternativa.vue'

const props = defineProps({
  alternativas: Array,
  respostas: Object,
  tipoOpcao: Object,
  assessment: Object,
})

const emit = defineEmits(['click:evidencia'])
</script>

<style lang="scss" scoped></style>
